class CardRepublicMemberScore extends HTMLElement {
  connectedCallback() {
    this.selects = Array.from(this.querySelectorAll('[data-cr-score-input]'));
    this.total = this.querySelector('[data-cr-score-total]');
    this.title = this.querySelector('[data-cr-score-title]');
    this.copy = this.querySelector('[data-cr-score-copy]');
    this.resetButton = this.querySelector('[data-cr-score-reset]');
    this.strings = window.cardRepublicStrings?.memberScore || {};

    if (!this.selects.length || !this.total || !this.title || !this.copy) return;

    this.onChange = this.update.bind(this);
    this.onReset = this.reset.bind(this);

    this.selects.forEach((select) => select.addEventListener('change', this.onChange));
    this.resetButton?.addEventListener('click', this.onReset);
    this.update();
  }

  disconnectedCallback() {
    this.selects?.forEach((select) => select.removeEventListener('change', this.onChange));
    this.resetButton?.removeEventListener('click', this.onReset);
  }

  update() {
    const score = this.selects.reduce((sum, select) => sum + Number(select.value || 0), 0);
    this.total.textContent = `${score} / 14`;

    let title = this.strings.fill || 'Complete all 7 points';
    let copy = this.strings.fillCopy || '';

    if (score <= 5) {
      title = this.strings.bad || title;
      copy = this.strings.badCopy || copy;
    } else if (score <= 9) {
      title = this.strings.price || title;
      copy = this.strings.priceCopy || copy;
    } else if (score <= 12) {
      title = this.strings.interesting || title;
      copy = this.strings.interestingCopy || copy;
    } else {
      title = this.strings.strong || title;
      copy = this.strings.strongCopy || copy;
    }

    this.title.textContent = title;
    this.copy.textContent = copy;
  }

  reset() {
    this.selects.forEach((select) => {
      select.value = '0';
    });
    this.update();
  }
}

if (!customElements.get('card-republic-member-score')) {
  customElements.define('card-republic-member-score', CardRepublicMemberScore);
}
